import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Api } from "~/api";
import Input from "~/components/common/input";
import { UserFields } from "~/types/cart";

import { setParam } from "../../../../../../redux/action-creaters/cart";
import styles from "./index.module.scss";

export default function Address() {
  const dispatch = useDispatch();
  const { params, isParamsLoaded } = useSelector((state: any) => state.cart);
  const [street, setStreet] = useState("");
  const [house, setHouse] = useState("");
  const [korpus, setKorpus] = useState("");
  const [flat, setFlat] = useState("");
  const [comment, setComment] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (isParamsLoaded) {
      dispatch(
        setParam({
          ...params,
          [UserFields.address]: JSON.stringify({
            street,
            house,
            korpus,
            flat,
            comment,
          }),
        }),
      );
    }
  }, [street, house, korpus, flat, comment]);

  useEffect(() => {
    if (params[UserFields.address] && !loaded) {
      const adr = JSON.parse(params[UserFields.address]);
      setStreet(adr.street);
      setHouse(adr.house);
      setKorpus(adr.korpus);
      setFlat(adr.flat);
      setComment(adr.comment);
      setLoaded(true);
    }
  }, [params]);
  const { cityName } = useSelector((state: any) => state.location);

  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const suggestionsWithoutCity = useMemo(() => {
    return suggestions.map((suggestion: any) => {
      const [city, ...address] = suggestion.value.split(", ");
      return address;
    });
  }, [suggestions]);

  useEffect(() => {
    if (query.length < 3) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      try {
        const data = await Api.dadata.getAddress(query, cityName);
        setSuggestions(data.suggestions || []);
      } catch (error) {
        console.error("Ошибка загрузки подсказок:", error);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [query]);

  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      // @ts-ignore
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.Address}>
      <div className={styles.Title}>Адрес доставки</div>
      <div className={styles.Inputs}>
        <div>
          <div className={styles.StreetWrapper} ref={containerRef}>
            <Input
              classProp={styles.Street}
              placeholder="Улица"
              value={street}
              onChange={async (value: any) => {
                setQuery(value);
                setStreet(value);
              }}
              onClick={() => {
                setQuery(street);
              }}
            />
            {suggestionsWithoutCity.length > 0 && (
              <div className={styles.Dropdown}>
                <ul className={styles.OptionsList}>
                  {suggestionsWithoutCity.map((s) => (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
                    <li
                      key={s}
                      className={styles.Option}
                      onClick={() => {
                        setStreet(s);
                        setSuggestions([]);
                      }}
                    >
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <Input
            placeholder="Квартира/офис"
            value={house}
            onChange={(value: any) => {
              setHouse(value);
            }}
          />
          <Input
            placeholder="Подъезд"
            value={korpus}
            onChange={(value: any) => {
              setKorpus(value);
            }}
          />
          <Input
            placeholder="Этаж"
            value={flat}
            onChange={(value: any) => {
              setFlat(value);
            }}
          />
        </div>
        <div>
          <Input
            placeholder="Комментарий (например, наличие лифта)"
            value={comment}
            onChange={(value: any) => {
              setComment(value);
            }}
          />
        </div>
      </div>
    </div>
  );
}
